import _ from 'lodash';
import CONSTANT from '../../constant';
import Api from '../../services/api';
import Emitter from '../../services/emitter';
import Config from '../../config';
import path from 'path';
import store from '../index';
import History from '../../util/history';
import model from './model';
import { bufferToBase64, getFileName } from '../../util/index';

export const UPDATE = 'SPRITE_UPDATE';
export const LIST = 'SPRITE_LIST';
export const ADD = 'SPRITE_ADD';
export const REMOVE = 'SPRITE_REMOVE';
export const SELECTED = 'SPRITE_SELECTED';
export const FILELIST = 'SPRITE_FILELIST';
export const SPRITE_SAVE = 'SPRITE_SAVE';
export const SPRITE_REMOVE_EXT = 'SPRITE_REMOVE_EXT';
export const SPRITE_CLEAN_FILELIST = 'SPRITE_CLEAN_FILELIST';
export const SPRITE_EDIT_MODE = 'SPRITE_EDIT_MODE';
export const SPRITE_CHECKED = 'SPRITE_CHECKED';
export const SPRITE_MERGE = 'SPRITE_MERGE';
export const SPRITE_SEARCH = 'SPRITE_SEARCH';
export const SPRITE_TYPE = 'SPRITE_TYPE';
export const SPRITE_CLASSIFY_CHANGE = 'SPRITE_CLASSIFY_CHANGE';
export const SPRITE_PAGINATION_CHANGE = 'SPRITE_PAGINATION_CHANGE';

/**
 * 合并列表数据
 *
 * @returns
 */
const libs = async (cust, mbt, t) => {
    try {
        const custs = Config.defaultAssets.customize ? await Api.Sprite[cust]() : [];
        const ms = Config.defaultAssets.makeblock ? await Api.Sprite[mbt]() : [];
        const ss = Config.defaultAssets.scratch ? await Api.Sprite[t]() : [];
        return custs.concat(ms).concat(ss);
    } catch (error) {
        console.warn(error);
        return [];
    }
};

/**
 * 更新资源数据
 * @param {*} type
 */

const update = (type, data) => {
    console.log('sprite', 'update');
    const state = {
        type: UPDATE,
        spriteType: type,
        payload: {
            status: CONSTANT.REQUEST_STATUS.PENDING
        }
    };

    return async dispatch => {
        try {
            switch (type) {
                case CONSTANT.SPRITE_TYPE.LIBS:
                    state.payload[CONSTANT.SPRITE_TYPE.LIBS] = data.concat(await libs('customizeSprites', 'mbsprites', 'sprites'));
                    break;
                case CONSTANT.SPRITE_TYPE.COSTUMES:
                    state.payload[CONSTANT.SPRITE_TYPE.COSTUMES] = data.concat(await libs('customizeCostumes', 'mbcostumes', 'costumes'));
                    break;
                case CONSTANT.SPRITE_TYPE.BACKDROPS:
                    state.payload[CONSTANT.SPRITE_TYPE.BACKDROPS] = data.concat(await libs('customizeBackdrops', 'mbbackdrops', 'backdrops'));
                    break;
                case CONSTANT.SPRITE_TYPE.SOUNDS:
                    state.payload[CONSTANT.SPRITE_TYPE.SOUNDS] = data.concat(await libs('customizeSounds', 'mbsounds', 'sounds'));
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.warn(error);
        }
        state.payload.status = CONSTANT.REQUEST_STATUS.DONE;
        dispatch(state);
    };
};

/**
 * 精灵角色列表
 *
 * @returns
 */
const list = (type) => {
    console.log('sprite', 'list');
    const state = {
        type: LIST,
        payload: {
            status: CONSTANT.REQUEST_STATUS.PENDING
        }
    };

    return async dispatch => {
        try {
            switch (type) {
                case CONSTANT.SPRITE_TYPE.LIBS:
                    state.payload[CONSTANT.SPRITE_TYPE.LIBS] = await libs('customizeSprites', 'mbsprites', 'sprites');
                    break;
                case CONSTANT.SPRITE_TYPE.COSTUMES:
                    state.payload[CONSTANT.SPRITE_TYPE.COSTUMES] = await libs('customizeCostumes', 'mbcostumes', 'costumes');
                    break;
                case CONSTANT.SPRITE_TYPE.BACKDROPS:
                    state.payload[CONSTANT.SPRITE_TYPE.BACKDROPS] = await libs('customizeBackdrops', 'mbbackdrops', 'backdrops');
                    break;
                case CONSTANT.SPRITE_TYPE.SOUNDS:
                    state.payload[CONSTANT.SPRITE_TYPE.SOUNDS] = await libs('customizeSounds', 'mbsounds', 'sounds');
                    break;
                case CONSTANT.SPRITE_TYPE.USER_LIBS:
                case CONSTANT.SPRITE_TYPE.USER_COSTUMES:
                case CONSTANT.SPRITE_TYPE.USER_BACKDROPS:
                case CONSTANT.SPRITE_TYPE.USER_SOUNDS:
                    state.payload[type] = await Api.Sprite.custom(type);
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.warn(error);
        }
        state.payload.status = CONSTANT.REQUEST_STATUS.DONE;
        dispatch(state);
    };
};

/**
 * 筛选
 *
 * @param {any} type
 * @param {any} text
 * @returns
 */
const search = (type, text) => {
    const state = {
        type: SPRITE_SEARCH,
        payload: {
            searchText: text
        }
    };
    return (dispatch, getState) => {
        const { sprite } = getState();
        const { backup, originFilstList } = sprite;
        if (!_.has(backup, type) || _.isEmpty(backup[type])) {
            backup[type] = sprite[type];
        }
        if (!_.isEmpty(sprite['fileList'])) {
            backup['fileList'] = originFilstList[type.indexOf('user') > -1 ? type : `user_${type}`];
        }
        try {
            if (!_.isEmpty(text)) {
                state.payload[type] = _.filter(backup[type], (item) => item.name.toLowerCase().indexOf(_.trim(text.toLowerCase())) !== -1);
            } else {
                state.payload[type] = backup[type];
            }
            state.payload['fileList'] = _.filter(backup['fileList'], (item) => item.name.toLowerCase().indexOf(_.trim(text.toLowerCase())) !== -1);
        } catch (error) {
            console.warn(error);
        }
        state.payload.backup = backup;
        dispatch(state);
    };
};

/**
 * 选择精灵
 *
 * @param {any} selected
 * @returns
 */
const selected = (selected) => {
    return {
        type: SELECTED,
        payload: {
            selected
        }
    };
};

/**
 * 用户点击添加角色
 *
 * @param {any} type
 * @returns
 */
const add = (type, data) => {
    return (dispatch) => {
        dispatch({ type: ADD, payload: { isAdding: true } });
        const cb = (isLoaded) => {
            dispatch({ type: ADD, payload: { selected: {}, isAdding: false } });
            isLoaded && History.push('/');
        };
        Emitter.emit('AddSprite', type, data, false, cb);
    };
};

/**
 * 移除用户自定义角色
 *
 * @param {any} sprite
 * @returns
 */
const remove = (sprite) => {
    return {
        type: REMOVE,
        payload: { sprite }
    };
};

/**
 * 保存扩展信息
 *
 * @param {any} { img, sprite }
 * @returns
 */
const save = ({ file, fileData, jsonData, type }) => {
    return async (dispatch, getState) => {
        let { fileList, originFilstList } = getState().sprite;
        const spriteData = _.cloneDeep(jsonData);
        file.status = CONSTANT.REQUEST_STATUS.PENDING;
        const _fileList = [{ ...file, sprite: spriteData }].concat(fileList);
        const data = (originFilstList[type] || []);
        data.unshift({ ...file, sprite: spriteData });
        originFilstList[type] = data;
        dispatch({
            type: SPRITE_SAVE,
            payload: { fileList: _fileList, originFilstList }
        });

        let isOk = true;
        try {
            const res = await Api.Sprite.upload(fileData);
            if (res) {
                Api.Sprite.write.call(Api.Sprite, jsonData, type, 'save');
            }
        } catch (error) {
            console.warn('sprite upload error', error);
            isOk = false;
        }
        fileList = getState().sprite.fileList;
        for (let i = 0; i < fileList.length; i++) {
            const ele = fileList[i];
            if (ele.md5 === spriteData.md5) {
                fileList[i].status = isOk ? CONSTANT.REQUEST_STATUS.DONE : CONSTANT.REQUEST_STATUS.FAILED;
                break;
            }
        }
        let selected = { source: file.source, ...spriteData };
        dispatch({
            type: SPRITE_SAVE,
            payload: { fileList, selected }
        });
    };
};

/**
 * 删除扩展信息
 *
 * @param {any} { sprite }
 * @returns
 */
const removeExt = ({ data, type }) => {
    const state = {
        type: SPRITE_REMOVE_EXT
    };
    return async (dispatch, getState) => {
        const { fileList, backup } = getState().sprite;
        let list = getState().sprite[type];
        const { md5 } = data;
        try {
            state.payload = { 'removeExtRequest': CONSTANT.REQUEST_STATUS.PENDING };
            dispatch(state);
            // 当删除角色或造型时，判断是否删除源文件
            let isExistAnother = false;
            let filePath = '';
            if (type === CONSTANT.SPRITE_TYPE.USER_LIBS) {
                filePath = path.join(Config.userSpriteFilePath, Config.spriteCustom[CONSTANT.SPRITE_TYPE.USER_COSTUMES]);
            } else if (type === CONSTANT.SPRITE_TYPE.USER_COSTUMES) {
                filePath = path.join(Config.userSpriteFilePath, Config.spriteCustom[CONSTANT.SPRITE_TYPE.USER_LIBS]);
            }
            if (filePath) {
                isExistAnother = await Api.Sprite.searchExistInJson(filePath, md5);
            }
            if (!isExistAnother) {
                await Api.Sprite.remove(data);
            }
            const res = await Api.Sprite.write.call(Api.Sprite, data, type, 'remove');
            if (res) {
                const _fileList = fileList.filter((f) => f.md5 !== md5);
                list = list.filter((i) => i.md5 !== md5);
                let _backup = backup;
                // 删除备份
                if (!_.isEmpty(backup['fileList'])) {
                    const backupFileList = backup['fileList'].filter((f) => f.md5 !== md5);
                    _backup = { ..._backup, fileList: backupFileList };
                }
                if (!_.isEmpty(backup[type])) {
                    const fileList = backup[type].filter((f) => f.md5 !== md5);
                    _backup = { ..._backup, [type]: fileList };
                }
                state.payload = { fileList: _fileList, [type]: list, selected: {}, backup: _backup, 'removeExtRequest': CONSTANT.REQUEST_STATUS.DONE };
                dispatch(state);
            }
        } catch (error) {
            console.warn(error);
        }
    };
};

/**
 * 清空上传的文件列表
 *
 * @returns
 */
const cleanFileList = () => {
    return {
        type: SPRITE_CLEAN_FILELIST,
        payload: {
            fileList: [],
            backup: {},
            originFilstList: {}
        }
    };
};

/**
 * 编辑模式
 *
 * @param {any} isEdit
 * @returns
 */
const editMode = (isEdit) => {
    return {
        type: SPRITE_EDIT_MODE,
        payload: { isEdit }
    };
};

/**
 * 选中的
 *
 * @param {any} checked
 * @returns
 */
const checked = (checked) => {
    return {
        type: SPRITE_CHECKED,
        payload: { checkedIndex: checked }
    };
};

/**
 * 绘制
 *
 * @param {any} type
 * @returns
 */
const draw = (type) => {
    return (dispatch, getState) => {
        const { sprite } = getState();
        try {
            let data = {
                name: 'Empty',
                md5: 'cd21514d0531fdffb22204e0ec5ed84a.svg',
                type: 'costume',
                tags: [],
                info: [0, 0, 1]
            };
            switch (type) {
                case CONSTANT.SPRITE_TYPE.LIBS:
                    data = _.filter(sprite[type], (item) => item.name.toLowerCase() === 'empty')[0];
                    break;
                case CONSTANT.SPRITE_TYPE.COSTUMES:
                    data.name = 'costume1';
                    break;
                case CONSTANT.SPRITE_TYPE.BACKDROPS:
                    data.name = 'backdrop1';
                    break;
                default:
                    break;
            }
            Emitter.emit('AddSprite', type, data, true);
        } catch (error) {
            console.warn(error);
        }
    };
};

/**
 * 合并
 *
 * @param {any} fromIndexs
 * @param {any} toIndex
 */
const merge = (fromIndexs, toIndex) => {
    const state = {
        type: SPRITE_MERGE,
        payload: {
            status: CONSTANT.REQUEST_STATUS.PENDING
        }
    };
    // list(CONSTANT.SPRITE_TYPE.USER_LIBS);
    return async dispatch => {
        dispatch(state);
        const type = CONSTANT.SPRITE_TYPE.USER_LIBS;
        try {
            const res = await Api.Sprite.merge(fromIndexs, toIndex);
            if (res) {
                state.payload[type] = await Api.Sprite.custom(type);
                state.payload.checkedIndex = [];
                state.payload.fileList = [];
                state.status = CONSTANT.REQUEST_STATUS.DONE;
            } else {
                state.status = CONSTANT.REQUEST_STATUS.FAILED;
            }
        } catch (error) {
            console.warn(error);
            state.status = CONSTANT.REQUEST_STATUS.FAILED;
        }
        dispatch(state);
    };
};

const type = (type) => {
    return {
        type: SPRITE_TYPE,
        payload: {
            type
        }
    };
};

const classifyChange = (classify) => {
    return {
        type: SPRITE_CLASSIFY_CHANGE,
        payload: classify
    };
};

const paginationChange = ({ paginationSettings, isChangePageAfterUpload }) => {
    return {
        type: SPRITE_PAGINATION_CHANGE,
        payload: {
            paginationSettings,
            isChangePageAfterUpload
        }
    };
};

const recordSound = (sound) => {
    const source = 'data:audio/wav;base64,' + bufferToBase64(sound.data);
    const id = getFileName(sound.md5);
    const name = sound.name;
    const property = {
        isSound: true
    };
    sound = model.sound(sound);
    const file = { id, name, md5: sound.md5, source, property };
    store.dispatch(save({ file, fileData: file, jsonData: sound, type: 'user_sounds' }));
    History.push('/sprite/sounds/user');
};

export default {
    update,
    list,
    selected,
    checked,
    add,
    draw,
    remove,
    save,
    removeExt,
    type,
    merge,
    search,
    editMode,
    cleanFileList,
    classifyChange,
    paginationChange,
    recordSound
};